module.exports = __webpack_public_path__ + "img/商品介紹_Web.4af16b33.png";